import * as CryptoJS from "crypto-js"; // 继续使用这个方式

const key = CryptoJS.enc.Utf8.parse("AD42F6697B035B7580E4FEF93BE20BAD"); // 密钥 后端提供
const iv = CryptoJS.enc.Utf8.parse("$JL<&*lZFsZ?:p#1"); // 偏移量

export default {
  // 加密
  /**
   * @description: 加密
   * @param {*} word
   * @param {*} keyStr
   */
  set(word, keyStr) {
    if (word && keyStr) {
      const srcs = CryptoJS.enc.Utf8.parse(word);
      const encrypted = CryptoJS.AES.encrypt(srcs, key, {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
    }
  },

  /**
   * @description: 解密
   * @param {*} word
   * @param {*} keyStr
   */
  get(word, keyStr) {
    if (word && keyStr) {
      try {
        const base64 = CryptoJS.enc.Base64.parse(word);
        const src = CryptoJS.enc.Base64.stringify(base64);
        const decrypt = CryptoJS.AES.decrypt(src, key, {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        });
        if (decrypt.sigBytes >= 0) {
          try {
            return CryptoJS.enc.Utf8.stringify(decrypt);
          } catch (e) {
            return word;
          }
        } else {
          return word;
        }
      } catch (e) {
        return word;
      }
    }
  },
};



// WEBPACK FOOTER //
// ./src/utils/cryptoJS.js